<div class="tcf">
  <header class="tcf-header">
    <h2>Invite user</h2>
    <p class="tcf-subtitle">We'll email this address a link to set up their account and sign in.</p>
  </header>

  <div class="tcf-body" [formGroup]="form">
    <label class="field">
      <span class="field-label">Email address <em>*</em></span>
      <input type="email" formControlName="emailAddress" autocomplete="email" cdkFocusInitial
             [class.invalid]="emailError || (form.get('emailAddress')?.invalid && form.get('emailAddress')?.touched)" />
      <span class="field-error" *ngIf="form.get('emailAddress')?.touched && form.get('emailAddress')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.get('emailAddress')?.hasError('email')">Invalid email</span>
      <span class="field-error" *ngIf="emailError">{{ emailError }}</span>
    </label>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" [disabled]="form.invalid || submitting" (click)="submit()">
      {{ submitting ? 'Sending…' : 'Send invite' }}
    </button>
  </footer>
</div>
